(function () {
  'use strict';
  if (window.casemiraShippingTabLoaded) return;
  window.casemiraShippingTabLoaded = true;

  function updateShippingTabs() {
    var engine = window.CasemiraDelivery;
    if (!engine) return;
    document.querySelectorAll('[data-casemira-shipping-tab]').forEach(function (tab) {
      var days = engine.transitDays(engine.currentCountry(), tab.dataset.vendor);
      var text = tab.dataset.estimateTemplate
        .replace('[days]', String(days));
      tab.querySelector('[data-shipping-estimate]').textContent = text;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateShippingTabs);
  } else {
    updateShippingTabs();
  }
  document.addEventListener('shopify:section:load', updateShippingTabs);
})();
